(function ($) {
    "use strict"; // Start of use strict

    $(document).ready(function () {
        // jQuery for page scrolling feature - requires jQuery Easing plugin
        $(document).on('click', 'a.page-scroll', function (event) {
            event.preventDefault();
            var $anchor = $(this);
            if (!$($anchor.attr('href')).offset()) return;
            $('html, body').stop().animate({
                scrollTop: ($($anchor.attr('href')).offset().top - 0)
            }, 1250, 'easeInOutExpo');
        });

        $(document).on('click', 'a#back_to_top', function (event) {
            event.preventDefault();
            $('html, body').stop().animate({
                scrollTop: 0
            }, 1250, 'easeInOutExpo');
        });

        var fixedElements = [];

        var recalcFixedElements = function () {
            fixedElements = $('div, nav, section, header').filter(function () {
                var $el = $(this);
                var isFixed = $el.css('position') === 'fixed';
                var isVisible = $el.is(':visible');
                var top = parseInt($el.css('top')) || 0;
                var depth = $el.parentsUntil('body').length;
                return isFixed && isVisible && top <= 200 && depth <= 4;
            });
        };

        var getFixedOffset = function () {
            var maxBottom = 0;
            fixedElements.each(function () {
                var $el = $(this);
                var top = parseInt($el.css('top')) || 0;
                var bottom = top + $el.outerHeight();
                var tooHeigh = (bottom > window.innerHeight * 0.66);
                if (!tooHeigh && bottom > maxBottom) maxBottom = bottom;
            });
            console.log('Calculated maxBottom:', maxBottom);
            return Math.max(100, maxBottom) ;
        };

        var scrollToHash = function () {
            setTimeout(function () {
                var hash = window.location.hash;
                var toAdd = 0;
                if (!hash || !$(hash).length) return;

                recalcFixedElements();

                var target = $(hash);
                var closestSection = target.closest("section");

                // nur übernehmen, wenn Section in der Nähe ist (≤ 200 px)
                if (closestSection.length) {
                    var distance = Math.abs(target.offset().top - closestSection.offset().top);
                    if (distance <= 200) {
                        console.log('Using closest section for scrolling:', closestSection);
                        target = closestSection;
                        toAdd = 40;
                    }
                }

                if (target.css("position") === "fixed") target = target.parent();

                var marginTop = parseInt(target.css('margin-top')) || 0;
                var offset = parseInt(target.offset().top - getFixedOffset() - marginTop - 50 + toAdd);
                console.log('Scrolling to offset:', offset);

                $('html, body').stop().animate({ scrollTop: offset }, 500, 'easeInOutExpo');
            }, 600);
        };

        $(window).on('load hashchange', scrollToHash);

        $(document).on('click', 'a[href^="#"]', function (e) {
            var targetHash = this.hash;
            if (!targetHash || !$(targetHash).length) return;

            e.preventDefault(); // verhindert Browser-Autoscroll
            history.pushState(null, null, targetHash); // setzt Hash manuell
            scrollToHash();
        });

        $(document).on('click', "a#scroll-down-svg", function (event) {
            event.preventDefault();
            $('html, body').stop().animate({
                scrollTop: 600
            }, 1250, 'easeInOutExpo');
        });

        $("body").paroller();

        $("a#back_to_top").hide();
        var onScroll = debounce(function (evt) {
            var lastScrollY = window.scrollY;
            if (lastScrollY > 200) {
                $("a#back_to_top").fadeIn();
                //$("a#scroll-down-svg").fadeOut();
            } else {
                $("a#back_to_top").fadeOut();
                //$("a#scroll-down-svg").fadeIn();
            }
        }, 300);
        window.addEventListener('scroll', onScroll);

        var onResize = debounce(function (evt) {
            /*
            $(".teaserboxes").each(function() {
                var overlayMaxHeight = 0;
                var contentMaxHeight = 0;
                var imageMinHeight = 400;
                var $tb = $(this);

                // adjust image holder
                $tb.find(".teaserbox .img-holder img").each(function() {
                    var thisHeight = $(this).height();
                    if (imageMinHeight > thisHeight && imageMinHeight > $(this).width() / 19 * 6) imageMinHeight = thisHeight;
                });
                $tb.find(".teaserbox .img-holder").height(imageMinHeight);

                // adjust lower-content
                $tb.find(".teaserbox .lower-content .content").each(function() {
                    var thisHeight = $(this).height() + parseInt($(this).css('margin-top'));
                    if (contentMaxHeight < thisHeight) contentMaxHeight = thisHeight;
                });
                $tb.find(".teaserbox .lower-content .content").height(contentMaxHeight);

                // adjust overlay
                $tb.find(".teaserbox .overlay .content").each(function() {
                    $(this).css({'height':'auto'});
                    var thisHeight = $(this).height() + parseInt($(this).css('margin-top'));
                    console.log(thisHeight);
                    if (overlayMaxHeight < thisHeight) overlayMaxHeight = thisHeight;
                });
                console.log($tb.innerHeight(), 2 * parseInt($tb.css('border-spacing')));
                $tb.find(".teaserbox .overlay .content").outerHeight(overlayMaxHeight);
                $tb.find(".teaserbox .img-holder, .teaserbox .img-holder img").height(imageMinHeight);
                $tb.find(".teaserbox .img-holder img").each(function() {
                    $(this).width($(this).parents(".img-holder").width());
                })
            })
            */

            var topPos = parseInt($("#mainNav").outerHeight());
            var zIndex = 8888;
            $(".sticky").trigger("sticky_kit:detach");
            $(".sticky").each(function () {
                $(this).stick_in_parent({
                    bottoming: false,
                    offset_top: topPos,
                    recalc_every: 10,
                    parent: "body",
                });
                //console.log(topPos);
                $(this).css("zIndex", zIndex--);
                topPos = topPos + parseInt($(this).outerHeight());
            });
            setVH();
            recalcFixedElements();
            setFixedTopMargin();

        }, 500);
        onResize();
        window.addEventListener('resize', onResize);


        // Highlight the top nav as scrolling occurs
        $('body').scrollspy({
            target: '.navbar-fixed-top',
            offset: 100
        });

        /******************************************* */
        /*** NAVIGATION **************************** */
        /******************************************* */

        // Closes the Responsive Menu on Menu Item Click
        $('.navbar-collapse ul li a').click(function () {
            if (!$(this).hasClass("dropdown-toggle")) {
                $('.navbar-toggle:visible').click();
            }
        });

        $('ul.dropdown-menu li.has-child > a').on("click", function (e) {
            if (matchMedia('only screen and (max-width: 767px)').matches) {
                console.log("toggle");
                e.stopPropagation();
                e.preventDefault();
                $(this).next('ul').toggle();
                return false;
            }
        });

        // Opens the Responsive Menu on Menu Item Mouseover
        $('.navbar-collapse ul li.has-child').on("hover",
            function () {
                $(this).addClass('open');
            },
            function () {
                $(this).removeClass('open');
            }
        );


        /******************************************* */
        /*** Flexslider **************************** */
        /******************************************* */

        var $flexEl = $('.flexslider');
        var customSpeed = parseInt($flexEl.data('speed'), 10);
        $flexEl.flexslider({
            animation: "fade", // fade or slide
            useCSS: false,
            slideshow: true,
            slideshowSpeed: (customSpeed >= 1000) ? customSpeed : 7000,
            animationSpeed: 2500,
            before: startCssAnimationsInSlide,
            start: startCssAnimationsOnStart,
            controlNav: false,
            touch: true
        });

        $('.flexslider2').flexslider({
            animation: "fade", // fade or slide
            useCSS: false,
            slideshowSpeed: 5000,
            animationSpeed: 2500,
            controlNav: true,
            touch: true
        });

        $('.bannerslider').flexslider({
            animation: "slide", // fade or slide
            useCSS: false,
            slideshowSpeed: 5000,
            animationSpeed: 2500,
            controlNav: true,
            touch: true
        });

        $('.accordion .panel-heading').click(function () {
            $(this).toggleClass("in").next().collapse('toggle');
        });

        $('.runningText .slider').flexslider({
            animation: "fade", // fade, slide, ...
            slideshowSpeed: 2500,
            animationSpeed: 500,
            pauseOnHover: true,
            directionNav: false,
        });

        function startCssAnimationsOnStart(slider) {
            startCssAnimationsInSlide(slider, true);
        }

        function setVH() {
            var height = (window.visualViewport && window.visualViewport.height)
                ? window.visualViewport.height
                : window.innerHeight;

            var factor = 100; // 2 decimals -> 10^2
            var vh = Math.round((height * 0.01) * factor) / factor;

            document.documentElement.style.setProperty('--vh', vh + 'px');
        }

        function setFixedTopMargin() {
            document.documentElement.style.setProperty('--fixed-top-margin', getFixedOffset() + 'px');
        }

        function startCssAnimationsInSlide(slider, isFirst) {
            var isFirst = isFirst || false;
            var nextSlideIdx = slider.currentSlide + 1 > slider.count - 1 ? 0 : slider.currentSlide + 1;
            if (isFirst === true) nextSlideIdx = 0;
            $(slider.slides[nextSlideIdx]).children("*[class*='animatejs-']").each(function (idx, el) {
                var classes = $(el).attr("class").split(' ');
                for (var i = 0; i < classes.length; i++) {
                    if (classes[i].indexOf('animatejs-') === 0) {
                        var aniClass = classes[i].substr(('animatejs-').length, 999);
                        $(el).animateCSS(aniClass);
                        break;
                    }
                }
            });
        }

        $('.animated').click(function (e) {
            $(this).animateRefresh('rotateInUpRight');
        });

        /*** Mouseover for Bootstrap Menues */
        $('ul.nav li').hover(function () {
            if (matchMedia('only screen and (max-width: 767px)').matches) return;
            $(this).children('a.dropdown-toggle').first().click(function () {
                if (matchMedia('only screen and (max-width: 767px)').matches) return; //ja, wird doppelt gebraucht :-)
                location.href = $(this)[0].href;
            });
            $(this).children('.dropdown-menu').first().stop(true, true).delay(200).fadeIn(500);
        }, function () {
            if (matchMedia('only screen and (max-width: 767px)').matches) return;
            $(this).children('.dropdown-menu').first().stop(true, true).delay(200).fadeOut(500);
        });

        $(".bs-select").selectpicker();
        $(".touchspin").TouchSpin({
            verticalbuttons: true
        });


        let scrollY = 0;

        function lockScroll() {
            // block scrolling on iPhone/Safari
            scrollY = window.scrollY || 0;
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;
            document.body.style.left = '0';
            document.body.style.right = '0';
            document.body.style.width = '100%';
        }

        function unlockScroll() {
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.left = '';
            document.body.style.right = '';
            document.body.style.width = '';
            window.scrollTo(0, scrollY);
        }

        $('.rGallery, .simpleGallery').each(function () {
            console.log("mfp init");
            $(this).magnificPopup({
                delegate: 'a',
                type: 'image',
                allowHTMLInTemplate: true,
                gallery: {
                    enabled: true,
                    tCounter: '<span class="mfp-counter">%curr% of %total%</span>'
                },
                image: {
                    tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
                    titleSrc: function (item) {
                        var title = item.img.attr('title') || item.el.attr('title') || item.el.find("img").attr("title") || "";
                        var alt = item.img.attr('alt') || item.el.attr('alt') || item.el.find("img").attr("alt") || "";
                        return title + '<small>' + alt + '</small>' + '<a href="#">download</a>';
                    }
                },

                callbacks: {
                    open: function () {
                        console.log("mfp opened");
                        lockScroll();
                        const mfp = this;

                        // auf den Popup-Wrapper binden (große Trefferfläche)
                        mfp.wrap.swipe({
                            swipeLeft: function () { console.log("swipe left"); mfp.next(); },
                            swipeRight: function () { console.log("swipe right"); mfp.prev(); },

                            // Feintuning
                            threshold: 30,
                            //allowPageScroll: "vertical",
                            // verhindert Konflikte z.B. beim Klick auf Close/Arrow
                            excludedElements: "button, a, .mfp-close, .mfp-arrow"
                        });
                    },

                    close: function () {
                        console.log("mfp closed");
                        unlockScroll();
                        // TouchSwipe wieder sauber entfernen
                        if (this.wrap && this.wrap.data('TouchSwipe')) {
                            this.wrap.swipe('destroy');
                        }
                    }
                }
            });
        });


        $('.fancybox').magnificPopup({
            type: 'image',
            gallery: {
                enabled: true
            },
            allowHTMLInTemplate: true,
            image: {
                tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
                titleSrc: function (item) {
                    var title = item.img.attr('title') || item.el.attr('title') || item.el.find("img").attr("title") || "";
                    var alt = item.img.attr('alt') || item.el.attr('alt') || item.el.find("img").attr("alt") || "";
                    console.log(item);
                    return title + '<small>' + alt + '</small>' + '<a href="/fileadmin/scripts/ranner_download.php?file=' + item.el.attr('href') + '" target="_blank">download</a>';
                }
            },
            callbacks: {
                open: function () {
                    console.log("mfp opened");
                    lockScroll();
                    const mfp = this;

                    // auf den Popup-Wrapper binden (große Trefferfläche)
                    mfp.wrap.swipe({
                        swipeLeft: function () { console.log("swipe left"); mfp.next(); },
                        swipeRight: function () { console.log("swipe right"); mfp.prev(); },

                        // Feintuning
                        threshold: 30,
                        //allowPageScroll: "vertical",
                        // verhindert Konflikte z.B. beim Klick auf Close/Arrow
                        excludedElements: "button, a, .mfp-close, .mfp-arrow"
                    });
                },

                close: function () {
                    console.log("mfp closed");
                    unlockScroll();
                    // TouchSwipe wieder sauber entfernen
                    if (this.wrap && this.wrap.data('TouchSwipe')) {
                        this.wrap.swipe('destroy');
                    }
                }
            }
        });

        $(".popup-link").magnificPopup({
            type: 'inline',
            midClick: true
        });

        $(".progress-bar").each(function () {
            $('.progress .progress-bar').css("width",
                function () {
                    var min = $(this).attr("aria-valuemin") || 0;
                    var max = $(this).attr("aria-valuemax") || 100;
                    var val = $(this).attr("aria-valuenow") || 0;
                    if (val == 0) return 0;
                    return ((val - min) * 100 / (max - min)) + "%";
                }
            )
        });

        $('a[href^="tel:"]').each(function () {
            var link = $(this);
            var tel_displayed = parseTel(link.html());
            var tel_linked = parseTel(link.attr("href"));
            var tel_readable = parseTel($(link).data("tel"));

            link.click(function (e) {
                e.preventDefault();
                tel_displayed = parseTel(link.html());
                if (tel_displayed) {
                    link.css({ "userSelect": "initial" });
                    location.href = ("tel:" + tel_displayed);
                } else if (tel_readable && !isMobile()) {
                    // show number
                    link.html(tel_readable);
                } else if (tel_linked) {
                    location.href = ("tel:" + tel_linked);
                }
            });
            return true;
        })
        $('a[href^="mailto:"]').each(function () {
            var link = $(this);
            var mailto_displayed = parseMail(link.html());
            var mailto_linked = parseMail(link.attr("href"));
            link.click(function (e) {
                e.preventDefault();
                link.css({ "userSelect": "initial" });
                mailto_displayed = parseMail(link.html());
                if (mailto_displayed) {
                    location.href = ("mailto:" + mailto_displayed);
                } else if (mailto_linked) {
                    link.html(mailto_linked);
                    setTimeout(function () {
                        location.href = ("mailto:" + mailto_linked);
                    }, 1000);
                }
            });
            return true;
        })

        /*
        new flexImages({
            selector: '.flex-images',
            rowHeight: 140
        });
        */

        // Replace registered R sign with <span class="regsign">®</span>
        $('h1, h2, li, p').html(function (_, html) {
            return html
                .replace(/&reg;/g, '<i class="regsign"></i>')
                .replace(/\u00AE/g, '<i class="regsign"></i>');
        });

    });

    // Copy Code
    $(document).on('click', '.copycode', function () {
        const $el = $(this);
        const content = $el.text();

        navigator.clipboard.writeText(content).then(function () {
            $el.addClass('copied');

            setTimeout(function () {
                $el.removeClass('copied');
            }, 12000);
        });
    });


})(jQuery); // End of use strict

function onYouTubeIframeAPIReady() {
    $("div[data-youtube-id]").each(function () {
        $(this).attr("id", $(this).attr("id") || $(this).attr("data-youtube-id"));
        createYTPlayer($(this).attr("id"));
    });

    function createYTPlayer(id) {
        var player = new YT.Player(id, {
            videoId: id, // YouTube Video ID
            width: 800, // Player width (in px)
            height: 500, // Player height (in px)
            playerVars: {
                autoplay: 0, // Auto-play the video on load
                controls: 1, // Show pause/play buttons in player
                showinfo: 0, // Hide the video title
                modestbranding: 1, // Hide the Youtube Logo
                loop: 1, // Run the video in a loop
                playlist: id,
                fs: 1, // Hide the full screen button
                cc_load_policy: 0, // Hide closed captions
                iv_load_policy: 3, // Hide the Video Annotations
                autohide: 0, // Hide video controls when playing
            },
            events: {
                onReady: function (e) {
                    e.target.mute();
                    setInterval(function () {
                        if ($('iframe#' + id).parent().is(':in-viewport' || $('iframe#' + id).is(':in-viewport'))) {
                            player.playVideo();
                        } else {
                            player.pauseVideo();
                        }
                    }, 1000);
                }
            }
        });
    }
}

function initGoogleMap() {

    $('div[data-map-center]').each(function () {
        var mapEl = $(this);
        draw(mapEl[0], $(this).data("map-center"), $(this).data("map-zoom"), $(this).data("map-radius"), $(this).data("map-type"), $(this).data("map-infotext"));
    })

    function draw(el, center, zoom, radius, type, infotext) {
        // Create the map.
        var map = new google.maps.Map(el, {
            zoom: zoom,
            center: center,
            mapTypeId: (type || 'terrain'),
            styles: [{
                "featureType": "landscape.natural",
                "elementType": "geometry.fill",
                "stylers": [{
                    color: "#dfe8e5"
                }]
            }]
        });

        if (center.place) {
            var directionsButton = $('<button id="start_navigation"><i class="fa fa-compass" style="font-size:1.2em"></i> Navigation</button>')
                .css({
                    fontSize: "16px",
                    backgroundColor: "white",
                    border: "1px solid #ccc",
                    borderTop: "none",
                    borderRadius: "0 0 3px 3px",
                    padding: "6px"
                })
                .click(function () {
                    window.open("https://www.google.com/maps/dir/?api=1&destination=" + center.place);
                })
            map.controls[google.maps.ControlPosition.TOP_CENTER].push(directionsButton[0]);
        }

        // Add the circle for this city to the map.
        var cityCircle = {};
        if (radius && radius > 0) cityCircle = new google.maps.Circle({
            strokeColor: '#dff0d8',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: '#dff0d8',
            fillOpacity: 0.35,
            map: map,
            center: center,
            radius: parseInt(radius)
        });

        var marker = new google.maps.Marker({
            position: center,
            map: map
        })

        var infowindow = new google.maps.InfoWindow({
            content: infotext
        });

        marker.addListener('click', function () {
            infowindow.open(map, marker);
        });
    }


}

// helper function
function debounce(func, wait) {
    // we need to save these in the closure
    var timeout, args, context, timestamp;

    // this is where the magic happens
    var later = function () {

        // how long ago was the last call
        var last = Date.now() - timestamp;

        // if the latest call was less that the wait period ago
        // then we reset the timeout to wait for the difference
        if (last < wait) {
            timeout = setTimeout(later, wait - last);

            // or if not we can null out the timer and run the latest
        } else {
            timeout = null;
            func.apply(context, args);
        }
    };

    return function () {

        // save details of latest call
        context = this;
        args = arguments;
        timestamp = Date.now();

        // we only need to set the timer now if one isn't already running
        if (!timeout) {
            timeout = setTimeout(later, wait);
        }
    }
}

function parseTel(tel) {
    if (!tel || !tel.match) return false;
    result = tel.match(/[+]{0,2}\d+[\(\)\/\-\s\.\d]{5,15}\d/g);
    return (result && result.length == 1 ? result[0] : false);
}

function parseMail(mail) {
    if (!mail || !mail.match) return false;
    result = mail.match(/[a-zA-Z0-9._%+-]+\@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}/g);
    return (result && result.length == 1 ? result[0] : false);
}

function isMobile() {
    return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
        && ('ontouchstart' in document.documentElement);
}